export default {"src":"/login-app/[GIT_HASH]/_next/static/media/observation_started.47f20fab.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};